/**
 * @flow
 **/

import React, { Component } from 'react';
import { observer } from 'mobx-react';
import Booking from './';
import CloseButton from '../../../Components/CloseButton';
import { Row, Col } from 'reactstrap';
import { translate  } from 'react-i18next';
import FlightOffer from '../../../Store/FlightOffer';
import FlightOfferBookingRequest from '../../../Store/Booking/BookingRequest';

type Props = {
  flightOffer: FlightOffer,
  booking: FlightOfferBookingRequest,
  onBook: (bookingRequest: FlightOfferBookingRequest) => void,
  onClose: () => void,
  t: any,
};

@observer
export class Mobile extends React.Component<Props> {

  render() {
    const { flightOffer, booking, onBook, t } = this.props;

    console.log(flightOffer);
    return (
      <div className="mobile-booking">
        <Row>
          <Col>
            <div className="float-right">
              <CloseButton onClick={this.props.onClose} />
            </div>
            <h2>{t('{{flight.name}} buchen', { flight: {name: flightOffer.title} })}</h2>
          </Col>
        </Row>
        <Row>
          <Col>
            <Booking
              flightOffer={flightOffer}
              booking={booking}
              onBook={onBook}
              fullscreen={true}
            />
          </Col>
        </Row>
      </div>
    );
  }
}

export default translate ()(Mobile);



// WEBPACK FOOTER //
// ./src/App/FlightOffer/View/Booking/Mobile.js